import script from "./EditTenantView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTenantView.vue?vue&type=script&setup=true&lang=ts"

import "./EditTenantView.vue?vue&type=style&index=0&id=30f46d14&lang=scss"

const __exports__ = script;

export default __exports__